"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.table = exports.tableTop = exports.linkButton = exports.importantTerm = exports.bulletPoints = exports.lMarginBottomSmall = exports.textEmphasis = exports.zipLogo = exports.contractTermsKey = exports.contractTableCaption = exports.contractHeader = exports.content = exports.body = void 0;

var _react = require("@emotion/react");

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  border-spacing: 0;\n  width: 100%;\n\n  tr {\n    border-spacing: 0;\n  }\n\n  p {\n    margin: 0 0;\n  }\n\n  td {\n    padding-left: 8px;\n    margin: 8px 0;\n    font-size: 12px;\n    line-height: 14px;\n    color: ", ";\n  }\n\n  tr > td {\n    padding: 8px;\n    vertical-align: middle;\n    border-top: 1px solid ", ";\n  }\n\n  td:first-of-type {\n    width: 20%;\n    padding-left: 0;\n    font-weight: 500;\n    color: ", ";\n  }\n\n  tr > td:not(:last-of-type) {\n    border-right: 1px solid ", ";\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 16px;\n  display: block;\n  border-top: 1px solid ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  vertical-align: baseline;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  margin-bottom: 0;\n  font-weight: 500;\n  list-style-position: inside;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  margin-bottom: 0;\n  list-style-position: inside;\n  li {\n    padding-bottom: 4px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 8px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  page-break-before: always;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  height: 25px;\n  width: auto;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin: 8px 0;\n  font-weight: 500;\n  color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 8px 0;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 40px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: 14px;\n  line-height: 19px;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  padding-right: 28px;\n  padding-bottom: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var body = (0, _react.css)(_templateObject());
exports.body = body;

var content = function content(_ref) {
  var colors = _ref.colors,
      fontWeights = _ref.fontWeights;
  return (0, _react.css)(_templateObject2(), fontWeights.normal, colors.neutral[500]);
};

exports.content = content;
var contractHeader = (0, _react.css)(_templateObject3());
exports.contractHeader = contractHeader;

var contractTableCaption = function contractTableCaption(_ref2) {
  var colors = _ref2.colors;
  return (0, _react.css)(_templateObject4(), colors.neutral[600]);
};

exports.contractTableCaption = contractTableCaption;

var contractTermsKey = function contractTermsKey(_ref3) {
  var colors = _ref3.colors;
  return (0, _react.css)(_templateObject5(), colors.neutral[600]);
};

exports.contractTermsKey = contractTermsKey;
var zipLogo = (0, _react.css)(_templateObject6());
exports.zipLogo = zipLogo;
var textEmphasis = (0, _react.css)(_templateObject7());
exports.textEmphasis = textEmphasis;
var lMarginBottomSmall = (0, _react.css)(_templateObject8());
exports.lMarginBottomSmall = lMarginBottomSmall;
var bulletPoints = (0, _react.css)(_templateObject9());
exports.bulletPoints = bulletPoints;
var importantTerm = (0, _react.css)(_templateObject10());
exports.importantTerm = importantTerm;
var linkButton = (0, _react.css)(_templateObject11());
exports.linkButton = linkButton;

var tableTop = function tableTop(_ref4) {
  var colors = _ref4.colors;
  return (0, _react.css)(_templateObject12(), colors.neutral[200]);
};

exports.tableTop = tableTop;

var table = function table(_ref5) {
  var colors = _ref5.colors;
  return (0, _react.css)(_templateObject13(), colors.neutral[500], colors.neutral[200], colors.neutral[600], colors.neutral[200]);
};

exports.table = table;